import { ArrowRight } from 'lucide-react';
import { Link } from './Link.tsx';

interface BigTileProps {
  /** Colour family: computer (blue), friend (green), join (purple) or online (orange). */
  kind: 'computer' | 'friend' | 'join' | 'online';
  art: string;
  title: string;
  desc: string;
  go: string;
  href?: string;
  onClick?: () => void;
}

/** A huge, colourful choice card: a link when given `href`, otherwise a button. */
export function BigTile({ kind, art, title, desc, go, href, onClick }: BigTileProps) {
  const body = (
    <>
      <span className="mode-art emoji" aria-hidden="true">
        {art}
      </span>
      <span className="mode-title">{title}</span>
      <span className="mode-desc">{desc}</span>
      <span className="mode-go" aria-hidden="true">
        {go} <ArrowRight size={22} strokeWidth={3} />
      </span>
    </>
  );
  return href ? (
    <Link href={href} className={`mode-tile ${kind}`}>
      {body}
    </Link>
  ) : (
    <button type="button" className={`mode-tile ${kind}`} onClick={onClick}>
      {body}
    </button>
  );
}
